import { render, staticRenderFns } from "./ApuracaoContratoTabela.vue?vue&type=template&id=5aea5378"
import script from "./ApuracaoContratoTabela.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoTabela.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoContratoTabela.vue?vue&type=style&index=0&id=5aea5378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports